import React, { Component } from "react";
import { Icon } from "semantic-ui-react";
import FirebaseLogin from "../../../components/FirebaseLogin";
import LinkButton from "../../../components/LinkButton";

import HeadImage from "../img/Implant.jpg";

class Head extends Component {
  render() {
    return (
      <section className="homepage-head">
        <div className="-inner">
          <div className="-data">
            <h1>#1 Social Network for Dentists</h1>
            <p>
              Casemasters is where dental experts come together to share their experience and learn from each other.{" "}
            </p>
            <p>Join over 100,000 dentists in 140 countries on Casemasters and be part of our global dental community</p>
            <FirebaseLogin className="-join">
              <Icon name="facebook f" />
            </FirebaseLogin>
            <LinkButton href="/signup" className="-primary" value="Create new account" />
          </div>
          <img className="-img" src={HeadImage} alt="" />
        </div>
      </section>
    );
  }
}

export default Head;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/components/Head.js